import { SVGProps } from 'react';

export const ErrorStatusIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="13.4922" cy="14.0508" r="13.5" fill="#EC4652" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.1279 9.49732C9.7997 9.16756 9.26704 9.16756 8.93888 9.49732C8.61152 9.82627 8.61152 10.359 8.93888 10.688L12.3064 14.0718L8.98213 17.4121C8.65477 17.741 8.65477 18.2738 8.98213 18.6027C9.31029 18.9325 9.84295 18.9325 10.1711 18.6027L13.4933 15.2644L16.8154 18.6027C17.1436 18.9324 17.6762 18.9324 18.0044 18.6027C18.3318 18.2737 18.3318 17.741 18.0044 17.412L14.6802 14.0718L18.0476 10.688C18.375 10.3591 18.375 9.82631 18.0476 9.49736C17.7195 9.16761 17.1868 9.16761 16.8587 9.49736L13.4933 12.8791L10.1279 9.49732Z"
                fill="white"
            />
        </svg>
    );
};
